export const name: string = 'Half Pivot Grid';
export const group = 'Charting';
export const moduleName: string = 'pdc-widget-half-pivot-grid';
export const icon: string = 'list-alt';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'pdc-widget-half-pivot-grid';

const prefix = 'widget-half-pivot-grid'

export const themeFields = {
    transposeColumnsToRows: prefix + 'transpose-columns-to-rows',

    themeGroup_ColumnHeaders: prefix + 'theme-group-column-headers',
    themeGroup_RowHeaders: prefix + 'theme-group-row-headers',
    themeGroup_Rows: prefix + 'theme-group-rows',
    themeGroup_Columns: prefix + 'theme-group-columns',

    columnHeaderFontColor: prefix + 'column-header-font-color',
    columnHeaderBackgroundColor: prefix + 'column-header-background-color',

    rowHeaderFontColor: prefix + 'row-header-font-color',
    rowHeaderBackgroundColor: prefix + 'row-header-background-color',
    rowHeaderWidth: prefix + 'row-header-width',
    rowHeaderAling: prefix + 'row-header-alignment',

    rowsFontColor: prefix + 'rows-font-color',
    rowsBackgroundColor: prefix + 'rows-background-color',
    columnsWidth: prefix + 'columns-width',
    columnsAlign: prefix + 'rows-alignment'
 }